import { localeAtom } from '@core/Atoms/Locale/Locale.atom';
import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { LocaleFilter } from '@core/Components/LocaleFilter/LocaleFilter';
import { DEFAULT_LOCALE } from '@core/Constants/Locale.constants';
import { FilterKey } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';
import SelectionControls from '@gds/SelectionControls/SelectionControls';

import { useAtomValue } from 'jotai';

import { useUpdateFilters } from 'Hooks/SearchFilters/UseUpdateFilters';

import { trackFilterEvent } from '../../Filters.tracking';

import styles from './BuyOnline.module.css';

const SUPPORTED_FILTERS = ['ecom', 'eligible-products', 'new-car-eu24'];

export const BuyOnline = ({ strings, isDisabled }: any) => {
  const { updateFilters } = useUpdateFilters();
  const filtersList = useAtomValue(filtersListAtom);
  const locale = useAtomValue(localeAtom);
  const buyOnline = getFilterFromArray('ecom', filtersList)?.value;
  const onlyOnHeycar = getFilterFromArray('d2c', filtersList)?.value;

  const handleChange = (filterId: FilterKey, eventTarget: EventTarget & HTMLInputElement) => {
    const isChecked = eventTarget.checked;

    const isSupportedFilter = SUPPORTED_FILTERS.includes(filterId);

    if (!isSupportedFilter) return;

    const value = isChecked ? (filterId === 'ecom' ? 'true' : 'ONLY_ON_HEYCAR') : undefined;

    trackFilterEvent(filterId, value ?? 'false', filtersList);
    updateFilters([{ id: filterId, value }]);
  };

  return (
    <div className={styles.toggleWrapper}>
      <div>
        <SelectionControls
          disabled={isDisabled}
          checked={buyOnline === 'true'}
          label={strings.ecom}
          onChange={e => handleChange('ecom', e.target as EventTarget & HTMLInputElement)}
          type="switch"
          isTooltip
          toolTipText={strings.ecomDesc}
          toolTipClassName={styles.tooltip}
          customTooltipTextClassName={styles.tooltipText}
        />
      </div>
      <LocaleFilter includes={[DEFAULT_LOCALE]} locale={locale}>
        <div>
          <SelectionControls
            disabled={isDisabled}
            checked={onlyOnHeycar === 'true'}
            label={strings.d2cLabel2}
            onChange={e =>
              handleChange('eligible-products', e.target as EventTarget & HTMLInputElement)
            }
            type="switch"
            isTooltip
            toolTipText={strings.d2cDesc2}
            toolTipClassName={styles.tooltip}
            customTooltipTextClassName={styles.tooltipText}
          />
        </div>
      </LocaleFilter>
    </div>
  );
};
